<template>
  <div>
    <div class="row">
      <div class="col m-3 p-2">
        <h2 class="h4">
          Search for postcodes or area names
        </h2>
        <b-input v-model="search" type="text" class="col-12 col-md-6" placeholder="Begin by typing a postcode or area name (e.g. LE)" />
      </div>
    </div>
    <div class="row">
      <div class="col mt-3">
        <spinner v-if="busy" />
        <div v-else-if="!busy && results.length > 0" role="tablist">
          <div v-for="(group, id) in group(results)" :key="id" class="mb-1 accordion-items">
            <b-button variant="empty" class="pr-0 text-center ml-2" @click="add(group.children)">
              <font-awesome-icon class="mr-2 text-success" :icon="['fas', 'plus-circle']" />
            </b-button>
            <b-button v-b-toggle="'s-accordion-'+id" :variant="'empty'" class="pl-0 font-weight-normal accordion-toggle">
              <strong>{{ group.code }} ({{ group.children.length }})</strong>
              <font-awesome-icon class="mx-2" :icon="'chevron-right'" />
            </b-button>
            <b-collapse :id="'s-accordion-'+id" visible :accordion="'s-my-accordion-'+id">
              <ul class="list-unstyled ml-3 row">
                <li
                  v-for="(pc, pcid) in group.children"
                  :key="pcid"
                  class="my-1 col-4"
                  @click.stop.prevent="toggle(pc, isSelected(pc.id) ? 'remove' : 'add')"
                >
                  <b-checkbox :checked="isSelected(pc.id)" class="forced-pointer">
                    ({{ pc.name }})
                  </b-checkbox>
                </li>
              </ul>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "@/imports/mixins/debounce";
import {FOUND_COVERAGE_REGIONS} from "@/store/coverage/mutation-types";
import groupPostcodes from "@/imports/mixins/groupPostcodes";
import Spinner from "@/components/animation/Spinner";
import notification from "@/imports/mixins/notification";

export default {
  name: "PostcodeSearch",
  components: {Spinner},
  mixins: [debounce, groupPostcodes, notification],
  props: ['value'],
  data: function() {
    return {
      search: "",
      busy: false,
    }
  },
  computed: {
    results: {
      get: function() {
        return this.$store.state.coverage.FOUND_COVERAGE_REGIONS
      },
      set: function (value) {
        this.$store.commit(FOUND_COVERAGE_REGIONS, value);
      }
    },
  },
  methods: {
    getResults: function(value) {
      if (value !== '' && value !== null) {
        this.busy = true;
        this.$store.dispatch('findPostCode', value).then(() => {
          this.busy = false;
        })
      } else {
        this.results = [];
      }
    },
    remove: function(postCode) {
      this.notify(
        this.$bvToast,
        `Post code "${postCode.name}" removed`,
        null,
        'success'
      );
      this.$emit(
        'input',
        this.value
          .filter(pc => pc.id !== postCode.id)
          .sort((a,b) => a.name
            .localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}))
      );
    },
    add: function (postCode) {
      if (Array.isArray(postCode)) {
        this.notify(
          this.$bvToast,
          `All post codes in area "${postCode[0].name} (${postCode[0].parent.name})" added`,
          null,
          'success'
        );
        this.$emit('input', [...this.value, ...postCode.filter(pc => !this.isSelected(pc.id))]
          .sort((a,b) => a.name
            .localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}))
        );
      } else {
        this.notify(
          this.$bvToast,
          `Post code "${postCode.name}" added`,
          null,
          'success'
        );
        this.$emit('input', [...this.value, postCode]
          .sort((a,b) => a.name
            .localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}))
        );
      }
    },
    toggle: function(postCode, action) {
      return action === 'add' ? this.add(postCode) : this.remove(postCode);
    },
    isSelected: function(id) {
      return this.value.find(postCode => postCode.id === id) !== undefined;
    }
  },
  watch: {
    search: function(value) {
      this.getResults(value);
    },
    searchBy: function() {
      this.getResults(this.search);
    }
  },
  created: function() {
    this.results = [];
    this.getResults = this.debounce(this.getResults, 500);
  }
}
</script>

<style scoped lang="scss">
::v-deep .tab-content {
  border: none !important;
}
.forced-pointer {
  ::v-deep .custom-control-label {
    cursor:pointer !important;
  }
}
</style>
